import baseProcessor from 'Commons/redux/postProcessor/BaseProcessor';
import { viewRentAdjustmentDataFormatter } from 'External/containers/operations/components/rentAdjustment/utils/Utils';

export default (apiResult, callback, dispatch, localReqOptions) => {
    const processedData = baseProcessor(apiResult, callback, dispatch, localReqOptions);
    const { data = {} } = processedData;
    processedData.data = viewRentAdjustmentDataFormatter(data);
    return processedData;
};
